export default __webpack_public_path__ + "static/media/My_car_website_images-4_2.d0a40986.webp";